import { Component, Input, OnInit } from '@angular/core';
import * as highcharts from "highcharts";
@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit {
  @Input('data')
  set in(val){
    this.plotChart(val)
  }
  chartOptions = {}
  highcharts = highcharts
  constructor() { }

  ngOnInit(): void {
    // this.plotChart()
  }
  plotChart(data){
   return this.chartOptions= {
      chart: {
        type: "bar",
        height: 250
      },
      title: {
        text: "",
        enabled:false
      },
      subtitle: {
        text:
          '',
        enabled:false

      },
      xAxis: {
        categories:data.categories,
        title: {
          text: null
        },
        labels: {
          style:{
            fontSize:10.5,
            color:"#2C3A43",
          }
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
          align: "high"
        },
        labels: {
          overflow: "justify",
          style:{
            fontSize:11,
            color:"#2C3A43",
          },
          
        },
        
      },
      tooltip: {
        time:{
          useUTC:false
        },
        xDateFormat: '%d-%m-%y, %H:%M:%S',
        headerFormat:
        // '<span style="font-size:14px; font-weight:bolder">{series.name}<br/> </span>'
         "<span style='font-size:14px;'>{point.key} </span><table>",
        pointFormat:
          '<tr style="font-size:14px;"><td style="color:{series.color};padding:0">{point.key}: </td>' +
          '<td style="padding:0"><b>{point.y:.2f} ' +
          data?.unit +
          "</b></td></tr>",
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
        backgroundColor:"#eeeeee",
        borderColor:"#eeeeee",
        valueSuffix: " %"
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            style:{
              fontSize:10.5,
              fontWieght:'light',
              enabled: true,
              useHTML: true,
              inside: false,
            }
          }
        },
        series: {
          dataLabels: {    
          }
        }
      },
      // legend: {
      //   layout: "vertical",
      //   align: "right",
      //   verticalAlign: "top",
      //   x: -40,
      //   y: 80,
      //   floating: true,
      //   borderWidth: 1,
      //   backgroundColor: "#FFFFFF",
      //   shadow: true
      // },
      credits: {
        enabled: false
      },
      series: data.series
    };
  }
}
